import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import StaffingSection from '../components/StaffingSection';
import StatsSection from '../components/StatsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import GlobalPresenceSection from '../components/GlobalPresenceSection';
import StatementSection from '../components/StatementSection';
import { SectionRule } from '../components/motion';
import CTASection from '../components/CTASection';

const HomePage = () => (
  <>
    <Navbar />
    <main>
      <HeroSection />
      <SectionRule index="00" label="Manifesto" />
      <StatementSection />
      <SectionRule index="01" label="Capabilities" />
      <ServicesSection />
      <SectionRule index="02" label="Numbers" />
      <StatsSection />
      <SectionRule index="03" label="IT as a service" />
      <StaffingSection />
      <SectionRule index="04" label="Global presence" />
      <GlobalPresenceSection />
      <SectionRule index="05" label="Testimonials" />
      <TestimonialsSection />
      <SectionRule index="06" label="Contact" />
      <CTASection />
    </main>
    <Footer />
  </>
);

export default HomePage;
